module.exports = __webpack_public_path__ + "static/media/dille.f026aecc.png";